<div
  class="physical-credential d-flex flex-column align-items-center h-100 w-100 justify-content-center modal-main"
>
  <div class="header w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          (click)="navigateBack()"
        />
      </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="user-title m-auto">
          <app-with-tooltip [showHelpCursor]="true">
            {{ selectedSite?.siteName || ("MY_SITE" | translate) }}
          </app-with-tooltip>
        </span>
        <span class="modal-title m-auto">{{
          "MASTER_CREDENTIAL" | translate
        }}</span>
      </div>
      <span
        class="col-2 d-flex flex-row align-items-center justify-content-end"
      >
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="cross-button pointer-cursor"
          (click)="closeDialog()"
        />
      </span>
    </div>
  </div>
  <div
    class="d-flex flex-column justify-content-start w-100 p-2 form-container"
  >
    <div
      class="d-flex flex-column justify-content-center align-items-center view-credential pt-4"
    >
      <div
        class="credential-header d-flex flex-column justify-content-center align-items-center w-100"
      >
        <span class="credential-circle-icon">
          <img
            alt="Credential Icon"
            src="assets/svg/master-credential-card-grey.svg"
          />
        </span>
        <span class="title">
          {{ selectedMasterCredential?.name || "-" }}
        </span>
        <div
          class="status-badge"
          [ngClass]="{
            active:
              selectedMasterCredential?.status === ('ACTIVE' | translate) ||
              selectedMasterCredential?.status === ('CURRENT' | translate),
            pending:
              selectedMasterCredential?.status === ('PENDING' | translate),
            blocklisted:
              selectedMasterCredential?.status ===
              ('PENDING_BLOCKED' | translate),
            'ready-to-block':
              selectedMasterCredential?.status === ('BLOCKED' | translate)
          }"
        >
          {{
            selectedMasterCredential?.status === ("ACTIVE" | translate) ||
            selectedMasterCredential?.status === ("CURRENT" | translate)
              ? ("Active" | translate)
              : selectedMasterCredential?.status ===
                ("PENDING_BLOCKED" | translate)
              ? ("BLOCKLISTED" | translate)
              : selectedMasterCredential?.status === ("BLOCKED" | translate)
              ? ("READY_TO_BLOCK" | translate)
              : selectedMasterCredential?.status
              ? (selectedMasterCredential?.status | titlecase)
              : "-"
          }}
        </div>
      </div>
      <div
        class="credential-detail d-flex flex-column justify-content-center align-items-center w-100 mt-4"
      >
        <span
          class="detail-item d-flex flex-row justify-content-between w-100 align-items-center top-element px-3"
        >
          <span class="col-5">{{ "BADGE_ID" | translate }}</span>
          <span class="pr-2 col-7 text-right right-text">
            {{ selectedMasterCredential?.badgeId || "-" }}
          </span>
        </span>

        <span
          class="detail-item d-flex flex-row justify-content-between w-100 align-items-center middle-element px-3"
        >
          <span class="col-5">{{ "ACCESS" | translate }}</span>
          <span class="pr-2 col-7 text-right right-text">
            {{ selectedMasterCredential?.access || "-" }}
          </span>
        </span>

        <span
          class="detail-item d-flex flex-row justify-content-between w-100 align-items-center middle-element px-3 description-row"
        >
          <span class="col-4">{{ "DESCRIPTION" | translate }}</span>
          <span
            class="pr-2 col-8 right-text d-flex flex-row align-items-center"
          >
            <span
              class="description-text"
              [class.description-placeholder]="
                !selectedMasterCredential?.description
              "
              >{{
                selectedMasterCredential?.description ||
                  ("NOTE_PLACEHOLDER" | translate)
              }}</span
            >
            <button
              *ngIf="!isPMU"
              type="button"
              class="edit-btn ml-2"
              (click)="onEditDescription()"
            >
              <img
                src="/assets/svg/ico-edit.svg"
                alt="edit"
                class="edit-icon pointer-cursor"
                [class.edit-icon-no-description]="
                  !selectedMasterCredential?.description
                "
              />
            </button>
          </span>
        </span>

        <span
          class="detail-item d-flex flex-row justify-content-between w-100 align-items-center last-element px-3"
        >
          <span class="col-5">{{ "ASSIGN_TO" | translate }}</span>
          <span
            class="pr-2 col-7 text-right right-text"
            [title]="selectedMasterCredential?.assignTo || ''"
          >
            {{ selectedMasterCredential?.assignTo || "-" }}
          </span>
        </span>
      </div>

      <!-- Activity Section -->
      <div
        class="credential-detail d-flex flex-column justify-content-center align-items-center w-100 mt-3"
      >
        <span
          class="detail-item d-flex flex-row justify-content-between w-100 align-items-center top-element last-element px-3 pointer-cursor"
          (click)="onActivityClick()"
        >
          <span class="col-5">{{ "ACTIVITY" | translate }}</span>
          <span
            class="col-7 text-right d-flex flex-row justify-content-end align-items-center"
          >
            <button
              type="button"
              mat-icon-button
              aria-label="activity-btn"
              class="access-btn"
            >
              <mat-icon class="arrow-btn">arrow_forward_ios</mat-icon>
            </button>
          </span>
        </span>
      </div>
    </div>
  </div>
</div>
